(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-page"] && !Shopify.designMode) return;
  try {
    
  class ContactProductIssue extends HTMLElement {
    static ISSUE_VALUE = 'I have an issue with a product purchased';

    connectedCallback() {
      this._form = this.querySelector('form');
      this._reason = this.querySelector('[data-pi-trigger]');
      this._block = this.querySelector('[data-pi-block]');
      this._bestByUI = this.querySelector('[data-pi-bestby-ui]');
      this._bestBySF = this.querySelector('[data-pi-bestby-sf]');
      this._captcha = this.querySelector('[data-pi-captcha]');
      this._recaptcha = this.querySelector('.g-recaptcha');
      this._captchaError = this.querySelector('[data-pi-captcha-error]');
      this._email = this.querySelector('#ContactForm-email');
      this._blockedEmails = this._parseBlockedEmails();

      this._stampCaptcha();

      if (!this._reason || !this._block) return;

      this._onReasonChange = this._evaluate.bind(this);
      this._onBestByChange = this._syncBestByDate.bind(this);
      this._onSubmit = this._handleSubmit.bind(this);

      this._reason.addEventListener('change', this._onReasonChange);
      if (this._bestByUI) {
        this._bestByUI.addEventListener('change', this._onBestByChange);
        this._bestByUI.addEventListener('input', this._onBestByChange);
      }
      if (this._form) this._form.addEventListener('submit', this._onSubmit);

      this._evaluate();
    }

    disconnectedCallback() {
      this._reason?.removeEventListener('change', this._onReasonChange);
      this._bestByUI?.removeEventListener('change', this._onBestByChange);
      this._bestByUI?.removeEventListener('input', this._onBestByChange);
      this._form?.removeEventListener('submit', this._onSubmit);
    }

    _getRequireWhenVisibleControls() {
      if (!this._block) return [];
      return Array.from(
        this._block.querySelectorAll(
          'input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled])'
        )
      );
    }

    _clearValuesInsideBlock() {
      this._getRequireWhenVisibleControls().forEach((ctrl) => {
        if (ctrl.tagName === 'SELECT') {
          ctrl.selectedIndex = 0;
        } else {
          ctrl.value = '';
        }
        ctrl.setCustomValidity?.('');
      });
      if (this._bestBySF) this._bestBySF.value = '';
    }

    _setVisibility(show) {
      this._block.classList.toggle('is-visible', show);
      this._block.setAttribute('aria-hidden', show ? 'false' : 'true');

      this._getRequireWhenVisibleControls().forEach((ctrl) => {
        ctrl.toggleAttribute('required', show);
      });

      this._bestBySF?.removeAttribute('required');

      if (!show) this._clearValuesInsideBlock();
    }

    _evaluate() {
      const show = this._reason.value === ContactProductIssue.ISSUE_VALUE;
      this._setVisibility(show);
      if (show) this._syncBestByDate();
    }

    _stampCaptcha() {
      if (!this._captcha) return;
      try {
        const cfg = JSON.parse(this._captcha.value);
        cfg.ts = String(Date.now());
        this._captcha.value = JSON.stringify(cfg);
      } catch (e) {
        /* leave captcha_settings untouched if it can't be parsed */
      }
    }

    _toOrgDateFormat(iso) {
      if (!iso) return '';
      const parts = iso.split('-');
      if (parts.length !== 3) return '';
      const [yyyy, mm, dd] = parts;
      if (!yyyy || !mm || !dd) return '';
      return `${mm}/${dd}/${yyyy}`;
    }

    _syncBestByDate() {
      if (!this._bestByUI || !this._bestBySF) return;
      this._bestBySF.value = this._toOrgDateFormat(this._bestByUI.value);
    }

    // _handleSubmit(event) {
    //   this._syncBestByDate();
    //   this._stampCaptcha();
      
    //   if (!this._form.checkValidity()) {
    //     event.preventDefault();
    //     this._form.reportValidity();
    //   }
    // }

    _handleSubmit(event) {
      this._syncBestByDate();
      this._stampCaptcha();

      const nativeOk = this._form.checkValidity();
      const captchaOk = this._isCaptchaSolved();

      if (!nativeOk || !captchaOk) {
        event.preventDefault();
        this._showCaptchaError(!captchaOk);
        if (!nativeOk) this._form.reportValidity();
        return;
      }

      this._showCaptchaError(false);

      // Silent drop: a blocked email looks like a normal submit but never reaches Salesforce.
      if (this._isEmailBlocked()) {
        event.preventDefault();
        const retURL = this._form.querySelector('input[name="retURL"]')?.value;
        if (retURL) {
          window.location.assign(retURL);
        } else {
          this._form.reset();
        }
      }
    }

    _parseBlockedEmails() {
      const encoded = this.dataset.blockedEmails;
      if (!encoded) return [];
      try {
        return atob(encoded.replace(/-/g, '+').replace(/_/g, '/'))
          .split(/[\n\r,;]+/)
          .map((entry) => entry.trim().toLowerCase())
          .filter(Boolean);
      } catch (e) {
        return [];
      }
    }

    _isEmailBlocked() {
      if (!this._email || this._blockedEmails.length === 0) return false;
      const value = this._email.value.trim().toLowerCase();
      if (!value) return false;
      return this._blockedEmails.some((entry) =>
        entry.startsWith('@') ? value.endsWith(entry) : value === entry
      );
    }

    _isCaptchaSolved() {
      // No widget on the page (site key blank) → nothing to enforce.
      if (!this._recaptcha) return true;
      // Script hasn't loaded yet → treat as unsolved rather than letting it slip through.
      if (typeof grecaptcha === 'undefined') return false;
      return grecaptcha.getResponse().length > 0;
    }

    _showCaptchaError(show) {
      if (this._captchaError) this._captchaError.hidden = !show;
    }

  }

  if (!customElements.get('contact-product-issue')) {
    customElements.define('contact-product-issue', ContactProductIssue);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-list"] && !Shopify.designMode) return;
  try {
    
  class FaqListAccordion extends HTMLElement {
    connectedCallback() {
      this._items = Array.from(this.querySelectorAll('details.faq-list__item'));

      this._items.forEach((item) => {
        const answer = item.querySelector('.faq-list__answer');
        const summary = item.querySelector('summary');
        if (item.open) {
          if (answer) answer.style.maxHeight = answer.scrollHeight + 'px';
          item.classList.add('is-open');
          if (summary) summary.setAttribute('aria-expanded', 'true');
        } else {
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }
      });

      this._items.forEach((item) => {
        const summary = item.querySelector('summary');
        if (!summary) return;
        summary.addEventListener('click', (e) => {
          e.preventDefault();
          if (item.open) {
            this._close(item);
          } else {
            this._open(item);
          }
        });
      });
    }

    _open(target) {
      this._items.forEach((item) => {
        if (item !== target && item.open) this._close(item);
      });

      const answer = target.querySelector('.faq-list__answer');
      const summary = target.querySelector('summary');
      if (!answer) return;

      target.open = true;
      target.classList.add('is-open');
      answer.style.maxHeight = answer.scrollHeight + 'px';
      if (summary) summary.setAttribute('aria-expanded', 'true');
    }

    _close(target) {
      const answer = target.querySelector('.faq-list__answer');
      if (!answer) return;

      const summary = target.querySelector('summary');
      target.classList.remove('is-open');
      answer.style.maxHeight = '0px';
      if (summary) summary.setAttribute('aria-expanded', 'false');

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        target.open = false;
      } else {
        answer.addEventListener('transitionend', () => {
          target.open = false;
        }, { once: true });
      }
    }
  }

  if (!customElements.get('faq-list-accordion')) {
    customElements.define('faq-list-accordion', FaqListAccordion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutrition-facts-list"] && !Shopify.designMode) return;
  try {
    
  class NutritionFactsAccordion extends HTMLElement {
    connectedCallback() {
      this._items = Array.from(this.querySelectorAll('details.nutrition-facts__item'));

      this._items.forEach((item) => {
        const panel = item.querySelector('.nutrition-facts__panel');
        const summary = item.querySelector('summary');
        if (item.open) {
          if (panel) panel.style.maxHeight = panel.scrollHeight + 'px';
          item.classList.add('is-open');
          if (summary) summary.setAttribute('aria-expanded', 'true');
        } else {
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }
      });

      this._items.forEach((item) => {
        const summary = item.querySelector('summary');
        if (!summary) return;
        summary.addEventListener('click', (e) => {
          e.preventDefault();
          if (item.open) {
            this._close(item);
          } else {
            this._open(item);
          }
        });
      });
    }

    _open(target) {
      this._items.forEach((item) => {
        if (item !== target && item.open) this._close(item);
      });

      const panel = target.querySelector('.nutrition-facts__panel');
      const summary = target.querySelector('summary');
      if (!panel) return;

      target.open = true;
      target.classList.add('is-open');
      panel.style.maxHeight = panel.scrollHeight + 'px';
      if (summary) summary.setAttribute('aria-expanded', 'true');
    }

    _close(target) {
      const panel = target.querySelector('.nutrition-facts__panel');
      if (!panel) return;

      const summary = target.querySelector('summary');
      target.classList.remove('is-open');
      panel.style.maxHeight = '0px';
      if (summary) summary.setAttribute('aria-expanded', 'false');

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        target.open = false;
      } else {
        panel.addEventListener('transitionend', () => {
          target.open = false;
        }, { once: true });
      }
    }
  }

  if (!customElements.get('nutrition-facts-accordion')) {
    customElements.define('nutrition-facts-accordion', NutritionFactsAccordion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-faq"] && !Shopify.designMode) return;
  try {
    
  class PdpFaqAccordion extends HTMLElement {
    connectedCallback() {
      this._items = Array.from(this.querySelectorAll('details.pdp-faq__item'));

      // Initialise max-height, icon state, and aria-expanded for any items already open (e.g. open_by_default)
      this._items.forEach((item) => {
        const answer = item.querySelector('.pdp-faq__answer');
        const summary = item.querySelector('summary');
        if (item.open) {
          if (answer) {
            answer.style.maxHeight = answer.scrollHeight + 'px';
          }
          item.classList.add('is-open');
          if (summary) summary.setAttribute('aria-expanded', 'true');
        } else {
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }
      });

      // Intercept clicks on every summary
      this._items.forEach((item) => {
        const summary = item.querySelector('summary');
        if (!summary) return;
        summary.addEventListener('click', (e) => {
          e.preventDefault();
          if (item.open) {
            this._close(item);
          } else {
            this._open(item);
          }
        });
      });
    }

    _open(target) {
      // Close all other open items first
      this._items.forEach((item) => {
        if (item !== target && item.open) this._close(item);
      });

      const answer = target.querySelector('.pdp-faq__answer');
      const summary = target.querySelector('summary');
      if (!answer) return;

      target.open = true;
      target.classList.add('is-open');
      answer.style.maxHeight = answer.scrollHeight + 'px';
      if (summary) summary.setAttribute('aria-expanded', 'true');
    }

    _close(target) {
      const answer = target.querySelector('.pdp-faq__answer');
      if (!answer) return;

      const summary = target.querySelector('summary');
      target.classList.remove('is-open');
      answer.style.maxHeight = '0px';
      if (summary) summary.setAttribute('aria-expanded', 'false');

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        target.open = false;
      } else {
        answer.addEventListener('transitionend', () => {
          target.open = false;
        }, { once: true });
      }
    }
  }

  customElements.define('pdp-faq-accordion', PdpFaqAccordion);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-card"] && !Shopify.designMode) return;
  try {
    
  class ProductInfoDisclosure extends HTMLElement {
    connectedCallback() {
      const toggle = this.querySelector('[data-pic-toggle]');
      if (!toggle) return;
      const panelId = toggle.getAttribute('aria-controls');
      const panel = panelId ? document.getElementById(panelId) : null;
      if (!panel) return;

      this._toggle = toggle;
      this._panel = panel;
      this._handleClick = () => {
        const expanded = this._toggle.getAttribute('aria-expanded') === 'true';
        this._toggle.setAttribute('aria-expanded', String(!expanded));
        this._panel.hidden = expanded;
      };
      this._toggle.addEventListener('click', this._handleClick);
    }

    disconnectedCallback() {
      if (this._toggle && this._handleClick) {
        this._toggle.removeEventListener('click', this._handleClick);
      }
    }
  }

  if (!customElements.get('product-info-disclosure')) {
    customElements.define('product-info-disclosure', ProductInfoDisclosure);
  }

  } catch(e) { console.error(e); }
})();
})();
